import { MapGrouping } from '@ng-cloud/badger-core/map/groupings/map-grouping';
import { LaserScanObject } from '@ng-cloud/badger-core/map/objects/laser-scan-object';
import { LaserScan } from '@ng-cloud/badger-core/models/laser-scan';
import { Layers } from './map-layer';

@Layers([
  { name: 'laserScans', zIndex: 9 }
])
export class LaserScanGrouping extends MapGrouping<LaserScan, LaserScanObject> {

  createObject(laserScan: LaserScan): LaserScanObject {
    return new LaserScanObject(laserScan, this.storeMap, this.options);
  }
}
